import { reactive } from "vue";
(function (window) {
    "use strict";
    function defineStoreState() {
        var storeState = {
            debug: true,
            //state: {
            //    pageTitle: 'Home',
            //    pageSubTitle: null,
            //    data: null,
            //    clickYes: false
            //},
            state: reactive({
                pageTitle: "Home",
                pageSubTitle: null,
                data: null,
                clickYes: false,
                documentHasLoaded: false,
                showLoader: false,
                hideTitleBar: false
            }),
            setPageTitleAction(newValue) {
                if (this.debug) console.log("setPageTitleAction triggered with", newValue);
                this.state.pageTitle = newValue;
                console.log("this.state.pageTitle", this.state.pageTitle);
            },
            clearPageTitleAction() {
                if (this.debug) console.log("clearPageTitleAction triggered");
                this.state.pageTitle = "Home";
            },
            setPageSubTitle(newValue) {
                if (this.debug) console.log("setPageSubTitle triggered with", newValue);
                this.state.pageSubTitle = newValue;
            },
            setData(newValue) {
                if (this.debug) console.log("setData triggered with value", newValue);
                this.state.data = newValue;
            },
            setDocumentReady(newValue) {
                if (this.debug) console.log("setDocumentReady triggered with value", newValue);
                this.state.documentHasLoaded = newValue;
            },
            setShowLoader(showLoader){
                if (this.debug) console.log("showLoader triggered with value", showLoader);
                this.state.showLoader = showLoader;
            },
            setHideTitleBar(value){
                this.state.hideTitleBar = value;
            }
        };
        return storeState;
    }
    //define globally if it doesn't already exist
    if (typeof (storeState) === "undefined") {
        window.storeState = defineStoreState();
    } else {
        console.log("storeState already defined.");
    }
})(window);